import {
  ACCOUNT_EXTRA_DETAILS_PATH,
  BACKTESTING_EXTRA_DETAILS_PATH,
  BOT_EXTRA_DETAILS_PATH,
  COIN_EXTRA_DETAILS_PATH,
  GROUP_CONFIGURATION_PATH,
  MARKETPLACE_GROUP_PATH,
  QUICK_ONBOARDING_PATH,
  SIGNAL_EXTRA_DETAILS_PATH,
  TRADE_EXTRA_DETAILS_PATH,
} from "common/constants.ts";
import React, { useMemo, useState } from "react";
import { lazyLoad } from "utils/misc.tsx";
import useRoutesMatch from "utils/hooks/useRoutesMatch.ts";

const TradeDrawer = lazyLoad(
  () => import("features/trades/TradeDrawer/TradeDrawer")
);
const AssetDrawer = lazyLoad(
  () => import("features/portfolio/CoinDrawer/AssetDrawer")
);
const AccountDrawer = lazyLoad(
  () => import("features/portfolio/AccountDrawer/AccountDrawer")
);
const SignalDrawer = lazyLoad(
  () => import("features/signals/SignalDrawer/SignalDrawer")
);
const BotDrawer = lazyLoad(() => import("features/bots/BotDrawer/BotDrawer"));
const GroupDrawer = lazyLoad(
  () => import("features/newMarketplace/GroupExtraDetails/GroupDrawer")
);
const BacktestingDrawer = lazyLoad(
  () =>
    import(
      "features/bots/BotForm/Backtesting/ExtraDetailsDrawer/BacktestingDrawer"
    )
);
const GroupConfigurationDrawer = lazyLoad(
  () =>
    import(
      "features/configuration/GroupConfigurationDrawer/GroupConfigurationDrawer"
    )
);
const QuickOnboarding = lazyLoad(
  () => import("features/quickOnboarding/QuickOnboarding")
);

const useDrawers = () => {
  const drawers = useMemo(() => Object.values(PATH_TO_DRAWER), []);
  const [visitedIndices, setVisitedIndices] = useState<boolean[]>(
    DRAWER_PATHS.map(() => false)
  );
  const currentMatch = useRoutesMatch(DRAWER_PATHS)?.[0];
  const isDrawer = !!currentMatch;

  return {
    paths: DRAWER_PATHS,
    drawers,
    visitedIndices,
    setVisitedIndices,
    currentMatch,
    isDrawer,
  };
};

export default useDrawers;

const PATH_TO_DRAWER = {
  [COIN_EXTRA_DETAILS_PATH]: <AssetDrawer key="assetDrawer" />,
  [BOT_EXTRA_DETAILS_PATH]: <BotDrawer key="botDrawer" />,
  [ACCOUNT_EXTRA_DETAILS_PATH]: <AccountDrawer key="accountDrawer" />,
  [GROUP_CONFIGURATION_PATH]: (
    <GroupConfigurationDrawer key="groupConfigurationDrawer" />
  ),
  [SIGNAL_EXTRA_DETAILS_PATH]: <SignalDrawer key="signalDrawer" />,
  [MARKETPLACE_GROUP_PATH]: <GroupDrawer key="groupDrawer" />,
  [BACKTESTING_EXTRA_DETAILS_PATH]: (
    <BacktestingDrawer key="backtestingDrawer" />
  ),
  [TRADE_EXTRA_DETAILS_PATH]: <TradeDrawer key="tradeDrawer" />,
  [QUICK_ONBOARDING_PATH]: <QuickOnboarding />,
};

export const DRAWER_PATHS = Object.keys(PATH_TO_DRAWER);
